export default "__VITE_ASSET__BwIGtLds__"